<template>
  <section>
    <m-img src="@/mobile_plan/assets/image/2.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>